import voyageOptionsFromJson from "../../voyage_options/db/mapper";
import VoyageData from "./data";
import customRouteFromJson from "../../custom_route/mapper";
import vesselFromJson from "../../vessel/mapper";

export default function voyageDataFromJson(json) {
  return new VoyageData(
    json.id,
    json.theyr_id,
    json.route_id,
    json.route_theyr_id,
    json.vessel_id,
    json.vessel_theyr_id,
    json.company_id,
    json.description,
    new Date(json.start_time),
    json.status,
    voyageOptionsFromJson(json.voyage_options),
    customRouteFromJson(json.route),
    vesselFromJson(json.vessel),
    new Date(json.created_at)
  );
}
